import { faCirclePlus, faLocationDot } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, CardBody } from 'reactstrap'
import { SkillLabel } from '../JobDetails/Details'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getCareerJobs } from 'store/Recruitment/actions'
import { useDispatch } from 'react-redux'

import "./style.css"

function Jobs() {
  const dispatch = useDispatch()
  const { careerJobs } = useSelector((store) => store.recruitment)

  useEffect(() => {
    dispatch(getCareerJobs())
  }, [dispatch])

  return (
    <>
      <Card>
        <CardBody>
          <h1 className='text-center'>
            <span className='text-info'>+{careerJobs?.length ?? 0}</span> Job
            Opening{careerJobs?.length === 1 ? '' : 's'}
          </h1>
        </CardBody>
      </Card>
      <div
        className='job-cards-container'
        style={{ display: "grid", gap: "2rem"}}
      >
        {careerJobs && careerJobs.length
          ? careerJobs?.map((job) => (
              <Card key={job.id}>
                <CardBody
                  className='d-flex flex-column'
                  style={{ gap: '1.5rem', fontSize: '14px' }}
                >
                  <span>
                    {job.location} <FontAwesomeIcon icon={faLocationDot} />
                  </span>
                  <span className='title'>{job.title}</span>
                  <span>
                    <FontAwesomeIcon icon={faCirclePlus} /> {job.positions}{' '}
                    position{job.positions === 1 ? '' : 's'} available
                  </span>
                  <div
                    className='d-flex flex-wrap'
                    style={{ gap: '0.5rem 0.1rem' }}
                  >
                    {job.skills.map((skill) => (
                      <SkillLabel key={skill} skill={skill} />
                    ))}
                  </div>
                  <button
                    onClick={() =>
                      window.open(`/job/career?job=${job?.id}`, '_blank')
                    }
                    className='btn btn-info'
                  >
                    Read More
                  </button>
                </CardBody>
              </Card>
            ))
          : null}
      </div>
    </>
  )
}

export default Jobs
